import { Button } from "@ui/Button";
import { Icon } from "@ui/Icon";
import { Panel } from "@ui/Panel";
import { HStack } from "@ui/Stack";
import { createSignal, type JSX, Show } from "solid-js";
import AskGVTLogo from "~/modules/shared/gvtui/icons/AskGVTLogo.svg?raw";
import { AskConsumerSidebar } from "./AskConsumerSidebar";

type Props = {
	/** Right-aligned, opposite the menu button. */
	actions?: JSX.Element;
};

/**
 * Same mobile chrome as {@link MobileFrameHeader}: top bar + slide-out nav.
 * Renders {@link AskConsumerSidebar} in the panel instead of StudioMenu.
 */
export const ConsumerMobileFrameHeader = (props: Props) => {
	const [isOpen, setIsOpen] = createSignal(false);

	return (
		<header class="mobile-frame-header">
			<HStack align="center" spacing="medium">
				<Button
					onClick={() => setIsOpen(!isOpen())}
					symbol="menu"
					symbolRelativeSize={1.75}
					variant="text"
					theme="monochrome"
					shape="square"
					aria-label="Open Menu"
				/>
				<Icon
					icon={AskGVTLogo}
					fillWithCurrentColor={false}
					class="mobile-frame-header__logo"
				/>
			</HStack>
			<Show when={props.actions}>
				<HStack align="center" spacing="medium">
					{props.actions}
				</HStack>
			</Show>
			<Panel
				isOpen={isOpen}
				onToggle={() => setIsOpen(!isOpen())}
				title="Navigation"
				class="mobile-panel"
				symbol="menu"
				side="left"
				width="100%"
				theme="white"
			>
				<AskConsumerSidebar />
			</Panel>
		</header>
	);
};
